<template>
  <div>
    <div class="product-info">
      <b>{{$t('shopfloor.deviations.selectedProduct')}}</b> {{ productNumber }}
    </div>
    <div class="deviations">
      <div class="deviation-card" v-bind:key="index"
           v-for="(deviation, index) of getDeviationsOfOrderProduct(orderId, productNumber, ['PRESENT_ON_FLOOR'], pickLocation ? [pickLocation] : [])">
        <div class="card-label">{{$t('shopfloor.deviations.amount')}}</div>
        <div class="card-value" v-if="!deviation.undone">{{ deviation.amount }}</div>
        <div class="card-value" v-else>{{ deviation.originalAmount }}</div>
        <div class="card-label">{{$t('shopfloor.deviations.type')}}</div>
        <div class="card-value">{{$t('shopfloor.deviations.types.' + deviation.type)}}</div>
        <div class="card-label">{{$t('shopfloor.deviations.createdAt')}}</div>
        <div class="card-value">{{ deviation.created_at | parseDate }}</div>
        <div class="card-label">{{$t('shopfloor.deviations.createdBy')}}</div>
        <div class="card-value">{{ deviation.userName }}</div>
        <div class="card-label">{{$t('shopfloor.deviations.remark')}}</div>
        <div class="card-value">{{ deviation.remark ? deviation.remark : '-' }}</div>

        <div class="delete-button">
          <button class="btn btn-danger" :disabled="deletedDeviations.indexOf(deviation.id) > -1"  v-if="deviation.amount > 0" @click="undoDeviation(deviation)">
            <i class="fas fa-undo"></i> {{$t('shopfloor.deviations.undo')}}
          </button>
        </div>
      </div>
      <div v-if="!getDeviationsOfOrderProduct(orderId, productNumber, ['PRESENT_ON_FLOOR'], pickLocation ? [pickLocation] : []).length">
        <div class="no-products-card">
          <b>{{$t('shopfloor.deviations.noDeviations')}}</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "UndoDeviation",
  data() {
    return {
      typesToIncrement: ['shortage'],
      orderId: null,
      productNumber: null,
      location: null,
      pickLocation: null,
      locationAfterUndo: null,
      currentSwal: null,
      currentUndoingDeviation: null,
      deletedDeviations: []
    };
  },
  filters: {
    parseDate(value) {
      return moment(value.toDate()).format('DD-MM-YYYY HH:mm:ss')
    }
  },
  computed: {
    ...mapGetters('users', [
      'getMeBasic'
    ]),
    ...mapGetters('deviations', ['getDeviationsOfOrderProduct'])
  },
  methods: {
    ...mapActions('unloading', [
      'checkIfBarcodeIsLocation'
    ]),
    async barcodeScanned(barcode) {
      if (this.currentSwal) {
        const isLocation = await this.checkIfBarcodeIsLocation(barcode);
        if (isLocation) {
          this.$FB.collection('undo-deviations').add({
            ...this.currentUndoingDeviation,
            locationToMoveTo: isLocation,
            undoneBy: this.getMeBasic,
            undoneAt: new Date()
          });
          this.deletedDeviations.push(this.currentUndoingDeviation.id);
          this.showUndoneToast();
          this.currentSwal.close();
        }
      }
    },
    showScanLocationSwal() {
      const blinkingIcon = '<div style="text-align: center; animation: blink 5s infinite; font-size: 8rem;" class="truck-icon"><span class="far fa-barcode-read"></span></div>';
      this.currentSwal = this.$swal({
        title: this.$t('shopfloor.deviations.pickLocationScanDialog.title'),
        html: `<div>${this.$t('shopfloor.deviations.pickLocationScanDialog.message')}</div>`  + '<br/><br/>' + blinkingIcon,
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: this.$t('shopfloor.deviations.pickLocationScanDialog.dismiss'),
      });
      this.currentSwal.then(() => {
        this.currentUndoingDeviation = null;
        this.currentSwal = null;
      })
    },
    getRouteParams() {
      this.productNumber = this.$route.query.productNumber;
      this.pickLocation = (this.$route.query.picklocation === 'nolocation' || !this.$route.query.picklocation) ? null : this.$route.query.picklocation;
      this.location = this.$route.query.location;
      this.orderId = this.location === 'loading' ? parseInt(this.$route.query.orderId) : this.$route.query.orderId;
      this.openDBChannel();
    },
    async openDBChannel() {
      let where = [
        ['companyId', '==', this.getMeBasic.companyId],
        ['location', '==', this.location],
        ['orderId', '==', this.orderId],
        ['locationAdditional', '==', this.productNumber]]
      await this.$store.dispatch('deviations/openDBChannel', {where})
    },
    async undoDeviation(deviation) {
      if (this.typesToIncrement.indexOf(deviation.type) > -1) {
        this.currentUndoingDeviation = deviation;
        this.showScanLocationSwal();
      } else {
        this.$FB.collection('undo-deviations').add(deviation);
        this.deletedDeviations.push(deviation.id);
        this.showUndoneToast();
      }
    },
    showUndoneToast() {
      this.$swal({
        customClass: {
          header: 'align-items-center'
        },
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 5000,
        type: 'success',
        title: this.$t('shopfloor.deviations.undoneSuccess')
      });
    }
  },
  created() {
    this.getRouteParams();
    this.$barcodeScanner.barCodeEventBus.$on('barcodeScanned', this.barcodeScanned);
  },
  beforeDestroy() {
    this.$barcodeScanner.barCodeEventBus.$off('barcodeScanned', this.barcodeScanned);
  },
}
</script>

<style scoped lang="scss">

.card {
  margin: 1rem;
  background: white;
  box-shadow: 0px 1px 15px 1px #e1e1e1;
  padding: 1rem;
}

.product-info {
  @extend .card;
}

.no-products-card {
  @extend .card;
}

.deviation-card {
  @extend .card;

  display: grid;
  grid-template-columns: 10rem 1fr;
  grid-template-rows: repeat(6, auto);
  grid-column-gap: 12px;
  grid-row-gap: 0.5rem;

}

.delete-button {
  grid-area: 6 / 1 / 7 / 3;
}

.card-label {
  font-weight: bold;
}

.delete-icon {
  cursor: pointer;
  color: red;
  text-align: center;
}

.delete-button > button {
  width: 100%;
  font-family: inherit;
}
</style>